export const LogoMark = ({ className = "h-7 w-7" }) => (
  <img src="/brand/pitchally-mark.webp" alt="" width="96" height="96" className={`object-contain ${className}`} />
);

export const Logo = ({ className = "", testId = "site-logo" }) => (
  <span data-testid={testId} className={`inline-flex items-center ${className}`}>
    <img src="/brand/pitchally-logo.webp" alt="Pitchally" width="330" height="120" className="h-9 w-auto drop-shadow-[0_0_18px_rgba(242,101,49,0.35)] sm:h-10" />
  </span>
);
